export default __webpack_public_path__ + "static/media/performance-client.71abe8b7.png";